// US reports route map.
//
//   /reports                      report library (hub)
//   /reports/billing-summary      RPT-1 Billing Summary
//   /reports/billing-activity     RPT-2 Billing Activity Log
//   /reports/billing-exceptions   RPT-3 Billing Exceptions
//   /reports/lead-funnel          RPT-4 Lead Funnel
//   /reports/ar-aging             P2-1 AR Aging
//   /reports/revenue              P2-2 Revenue Register
//   /reports/payments             P2-3 Payments Register
//   /reports/usage-variance       P2-4 Usage Variance
//   /reports/sales-performance    P2-5 Sales Performance
//   /reports/renewal-risk         P2-6 Renewal Risk
//
// Role gating is `CrmShell`'s `ROUTE_ACCESS` entry for the `/reports` prefix
// (admin, manager, billing), which also hides the rail entry from other roles.
// Every page is lazy so the reports cost nothing until opened.
//
// The paths come from `REPORT_PATHS`, the same constants the hub's cards use,
// so a card and its route cannot drift apart.

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { REPORT_PATHS } from './services/reportsHub.service';

const ReportsHubPage = lazy(() =>
  import('./pages/ReportsHubPage').then((m) => ({ default: m.ReportsHubPage })),
);
const BillingSummaryPage = lazy(() =>
  import('./pages/BillingSummaryPage').then((m) => ({ default: m.BillingSummaryPage })),
);
const BillingActivityPage = lazy(() =>
  import('./pages/BillingActivityPage').then((m) => ({ default: m.BillingActivityPage })),
);
const BillingExceptionsPage = lazy(() =>
  import('./pages/BillingExceptionsPage').then((m) => ({ default: m.BillingExceptionsPage })),
);
const LeadFunnelPage = lazy(() =>
  import('./pages/LeadFunnelPage').then((m) => ({ default: m.LeadFunnelPage })),
);
const ArAgingPage = lazy(() => import('./pages/ArAgingPage').then((m) => ({ default: m.ArAgingPage })));
const RevenueRegisterPage = lazy(() =>
  import('./pages/RevenueRegisterPage').then((m) => ({ default: m.RevenueRegisterPage })),
);
const PaymentsRegisterPage = lazy(() =>
  import('./pages/PaymentsRegisterPage').then((m) => ({ default: m.PaymentsRegisterPage })),
);
const UsageVariancePage = lazy(() =>
  import('./pages/UsageVariancePage').then((m) => ({ default: m.UsageVariancePage })),
);
const SalesPerformancePage = lazy(() =>
  import('./pages/SalesPerformancePage').then((m) => ({ default: m.SalesPerformancePage })),
);
const RenewalRiskPage = lazy(() =>
  import('./pages/RenewalRiskPage').then((m) => ({ default: m.RenewalRiskPage })),
);

export const reportsRoutes: RouteObject[] = [
  { path: REPORT_PATHS.hub, element: <ReportsHubPage /> },
  { path: REPORT_PATHS.billingSummary, element: <BillingSummaryPage /> },
  { path: REPORT_PATHS.billingActivity, element: <BillingActivityPage /> },
  { path: REPORT_PATHS.billingExceptions, element: <BillingExceptionsPage /> },
  { path: REPORT_PATHS.leadFunnel, element: <LeadFunnelPage /> },
  { path: REPORT_PATHS.arAging, element: <ArAgingPage /> },
  { path: REPORT_PATHS.revenueRegister, element: <RevenueRegisterPage /> },
  { path: REPORT_PATHS.paymentsRegister, element: <PaymentsRegisterPage /> },
  { path: REPORT_PATHS.usageVariance, element: <UsageVariancePage /> },
  { path: REPORT_PATHS.salesPerformance, element: <SalesPerformancePage /> },
  { path: REPORT_PATHS.renewalRisk, element: <RenewalRiskPage /> },
];
